import React from 'react';

import MultichoiceFilterGroup from '../components/MultichoiceFilterGroup';
import type { IFilter } from '../types';

const FilterCountriesComponent = ({
  className = '',
  isMobile = false,
  ...props
}: IFilter): JSX.Element => (
  <MultichoiceFilterGroup
    className={className}
    isMobile={isMobile}
    {...props}
    Filter={FilterCountriesComponent}
    expandLabel="Показать все страны"
    visibleItems={5}
  />
);

export default Object.assign(FilterCountriesComponent, {
  filterName: 'countries',
  filterLabel: 'Страна',
});
